import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import '@/styles/class.scss'
import '@/styles/index.scss'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import request from '@/utils/request'
import Cookies from 'js-cookie'
import i18n from './lang/index'
import '@/assets/font/font.css'
import dayjs from 'dayjs'

import '@/utils/rem'
// import { isMobile } from '@/libs/utils';
import mobile from 'is-mobile'
import VueLazyload from 'vue-lazyload'
import VideoPlayer from 'vue-video-player'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

if (mobile()) {
    const params = location.href.slice(location.href.indexOf(location.pathname) + location.pathname.length)
    location.href = `${location.protocol}//${process.env.VUE_APP_H5_DOMAIN}${location.pathname}${params}`
} else {
    Vue.use(VueLazyload, {
        preLoad: 1.3,
        error: require('./assets/lazy-img.png'),
        loading: require('./assets/lazy-img.png'),
        attempt: 1,
    })
    Vue.config.productionTip = false
    Vue.prototype.$axios = axios
    Vue.prototype.dayjs = dayjs
    Element.Dialog.props.closeOnClickModal.default = true

    Vue.use(Element, {
        i18n: (key, value) => i18n.t(key, value),
    })

    Vue.prototype.$request = request

    Vue.use(VideoPlayer)
    require('vue-video-player/src/custom-theme.css')

    Vue.config.productionTip = false
    new Vue({
        el: '#app',
        i18n,
        store,
        router,
        render: h => h(App),
    })
}

// 百度统计代码
;(function () {
    var hm = document.createElement('script')
    hm.src = 'https://hm.baidu.com/hm.js?78985b7420cd6a0074282152943565cf'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
})()
// 谷歌统计代码
;(function () {
    var google = document.createElement('script')
    google.src = 'https://www.googletagmanager.com/gtag/js?id=AW-332666715'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(google, s)

    window.dataLayer = window.dataLayer || []
    function gtag() {
        dataLayer.push(arguments)
    }
    gtag('js', new Date())
    gtag('config', 'AW-332666715')
})()
// 谷歌统计代码
;(function () {
    var google = document.createElement('script')
    google.src = 'https://www.googletagmanager.com/gtag/js?id=G-MD86ZCQS4B'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(google, s)
    window.dataLayer = window.dataLayer || []
    function gtag() {
        dataLayer.push(arguments)
    }
    gtag('js', new Date())
    gtag('config', 'G-MD86ZCQS4B')
})()
